import { render } from "./ProfileVue.vue?vue&type=template&id=29e868e6"
import script from "./ProfileVue.vue?vue&type=script&lang=js"
export * from "./ProfileVue.vue?vue&type=script&lang=js"

import "./ProfileVue.vue?vue&type=style&index=0&id=29e868e6&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__